export default "__VITE_ASSET__DQ77Tgw9__"